import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { actions as transferActions } from "reducers/transfers";
import * as config from "util/config";

const useDebounce = () => {
    const [text, setText] = useState("");
    const [t, setT] = useState(null);
    const dispatch = useDispatch();
    const formRef = useRef(null);

    const onChangeDebounce = (_text) => {
        if (t) {
            clearTimeout(t);
        }
        const handleDebounce = () => {
            setText(_text);
        };

        setT(setTimeout(handleDebounce, 2250));
    };

    useEffect(() => {
        if (!formRef.current || !text) {
            return;
        }

        if (!formRef.current.frequentDestination && text.length >= config.getInteger("cbuSearch.min.required", 6)) {
            formRef.current.setSubmitting(true);
            dispatch(
                transferActions.requestAccountInfoByCbu({
                    creditCbu: text,
                    formikBag: formRef.current,
                }),
            );
        }
    }, [text]);
    return { onChangeDebounce, formRef, setT };
};

export default useDebounce;
